import React from 'react';
import PHRMobileIndex from './PHRMobileIndex';
import { usePhrMobileStoreInContext } from '@/stores/phrMobile';
import useGlobalMobileConfigs from '@/stores/globalConfigsMobile';
import PHRMobileInfo from './PHRMobileInfo';
import { Drawer } from 'antd';
import PHRMobileBodySystem from './PHRMobileBodySystem';
import emrService from '@/apis/emr/service';
import BaseAvatar from '@/components/bases/BaseAvatar';
import utils from '@/utils';
import { useNavigate } from 'react-router-dom';
import useAuth from '@/stores/auth';
import WrapRefresh from '../components/WrapRefresh';

const PHRMobile = () => {
  const navigate = useNavigate();
  const mainUser = useAuth((s) => s.user);
  const listMember = mainUser?.family?.members ?? [];
  const user = usePhrMobileStoreInContext((s) => s.user);
  const allMember = utils.filterArray([user?.family?.protector, ...listMember]);
  const components = usePhrMobileStoreInContext((s) => s.phr?.components);
  const bodySystem = useGlobalMobileConfigs((s) => s.phrConfigs?.bodySystem);
  const bodyIndex = useGlobalMobileConfigs((s) => s.phrConfigs?.bodyIndex);
  const refetchPhr = usePhrMobileStoreInContext((s) => s.refetchPhr);
  const getConfigs = useGlobalMobileConfigs((s) => s.getConfigs);

  const [openDrawer, setOpenDrawer] = React.useState(false);

  const healthsIndex = components?.reduce((d: any, e: IEMRData) => {
    d[e.type.code] = e;
    return d;
  }, {});
  const { data } = emrService.useCountHr(user?._id ?? '');
  const objCountBodySystem = data?.data?.reduce((d: any, e: any) => {
    d[e._id] = e.total;
    return d;
  }, {});

  const showDrawer = () => {
    setOpenDrawer(true);
  };

  const onClose = () => {
    setOpenDrawer(false);
  };

  const onRefresh = () => {
    getConfigs?.();
    refetchPhr?.();
  };

  return (
    <WrapRefresh onRefresh={onRefresh} refreshColor={'white'}>
      <div
        className="overflow-auto h-full"
        style={{ background: 'linear-gradient(180deg, #37D2D2 0% 50%, #fafafa 50% 100%)' }}
      >
        {/* Header */}
        <div className=" bg-mint-9 pb-4">
          <PHRMobileInfo
            user={user}
            showDrawer={showDrawer}
            listMember={listMember}
            isMainUser={user?._id === mainUser?._id}
          />
          <PHRMobileIndex
            navigate={navigate}
            user={user}
            healthsIndex={healthsIndex}
            bodyIndex={bodyIndex}
            onDetail={() => navigate(`/phr-mobile/detail/${user?._id ?? 'error/error'}`)}
          />
        </div>
        <div className="flex flex-col flex-grow pt-4 pb-4 bg-gray-2">
          <PHRMobileBodySystem navigate={navigate} config={bodySystem} objCount={objCountBodySystem} uid={user?._id} />
        </div>
      </div>
      <Drawer
        title="Chọn người dùng"
        placement={'bottom'}
        width={500}
        onClose={onClose}
        open={openDrawer}
        className={'rounded-t-3xl shadow-sm'}
      >
        <div className="overflow-y-auto">
          {[...allMember].map((member) => {
            const isActiveUser = member._id === user?._id;
            const relationObj = listMember?.find((m: any) => m._id === member._id);
            const relation =
              member._id === mainUser?._id ? 'Chủ tài khoản' : relationObj?.dependent?.relation?.dependent ?? '';
            return (
              <button
                onClick={() => {
                  onClose();
                  if (!isActiveUser) {
                    navigate(`/phr-mobile/${member._id}`);
                  }
                }}
                key={member._id}
                className="pb-3 bg-white flex flex-row items-center mb-3 border-gray-3 border-b-2 w-full text-violet-14"
              >
                <BaseAvatar
                  username={member?.username ?? ''}
                  src={member?.avatar ?? 'images/UserPortraits/avatar.png'}
                  className="w-9 h-9"
                />
                <div className="flex flex-1 flex-col items-start justify-center">
                  <span className="cms-h3 ml-4">{member.username}</span>
                  <span className="cms-body2 ml-4">{relation}</span>
                </div>
              </button>
            );
          })}
        </div>
      </Drawer>
    </WrapRefresh>
  );
};

export default PHRMobile;
